import React from 'react';
import { Button as LinkButton, Tooltip } from 'antd';
const Tip = (props) => (
  <Tooltip placement="right" title={props.title} className="iframe-col-tooltip">
    <span
      className="appkiticon icon-information-fill "
      style={{ marginLeft: '0.313rem' }}
    />
  </Tooltip>
);
const renderLinkButton = (
  <div>
    iFrame allows you to embed other webpages, documents, and other forms of
    multimedia without leaving the page. Please refer to the iFrame
    configuration{' '}
    <a
      target="_blank"
      href="/gateway/guide-shared"
      style={{ padding: 0, fontSize: '1rem' }}
    >
      <span style={{ textDecoration: 'underline' }}>here</span>
    </a>{' '}
    for additional instructions for PowerBI and Tableau.
  </div>
);
export const FORM_KEYS = {
  NAVI_NAME: {
    key: 'integrationNavigatorName',
    label: 'Navigator Name',
  },
  MODULE: {
    label: 'Tile Name',
    key: 'module',
    placeholder: 'Please enter the tile name',
  },
  SECTION: {
    label: 'Section',
    key: 'section',
    placeholder: 'Please enter the Section name',
  },
  TYPE: {
    label: 'Type',
    key: 'type',
  },
  DISPLAY: {
    label: 'Display?',
    key: 'display',
  },
  IFRAME: {
    label: (
      <>
        iFrame
        <Tip title={renderLinkButton} />
      </>
    ),
    labelFunc: () => (
      <>
        iFrame
        <Tip title={renderLinkButton} />
      </>
    ),
    key: 'iframe',
  },
  ORDER: {
    label: 'Order',
    key: 'order',
  },
  COLOR: {
    label: 'Color',
    key: 'color',
  },
  LINK: {
    label: 'Link',
    key: 'link',
    placeholder: 'Please enter the link here',
  },
  DES: {
    label: 'Description',
    key: 'description',
    placeholder: 'Please enter the description here',
  },
  DELETE: {
    key: 'id',
  },

  DRAG: {
    key: 'drag',
  },
  RATIO: {
    key: 'ratio',
    label: 'Report Ratio',
  },
  MultiType: {
    key: 'multiType',
    label: 'Type',
  },
};
